import { merge, isEqual } from 'lodash'

export default {
  data () {
    return {
      instantSearchRenderKey: 0,
      disjunctiveFacets: ['free_shipping', 'on_sale', 'in_stock'],
      facetingAfterDistinct: true,
      uiData: {
        appliedUiState: null,
        uiState: null,
        setUiState: null
      },
      mobile: false
    }
  },
  computed: {
    instantSearchParams () {
      return {
        searchClient: this.$searchClient,
        indexName: this.indexName,
        ref: 'aisInstantSearch',
        onStateChange: this.onStateChange,
        routing: this.routing,
        stalledSearchDelay: 60000,
        insights: true,
        future: {
          preserveSharedStateOnUnmount: true
        }
      }
    },
    indexName () {
      return this.$config.ALGOLIA_VARIANTS_INDEX_NAME
    },
    searchOnConfirmation () {
      return this.mobile
    }
  },
  updated() {
    this.setInitialAppliedUiState()
  },
  methods: {
  /**
   * Synchronizes the initial UI state to ensure that filters are correctly applied.
   * Without this method, filters might not be applied correctly on initial load.
   * It compares the current widget state with the stored applied UI state and, if they differ,
   * updates the applied state and triggers a re-render to apply the correct filters.
   */
    setInitialAppliedUiState () {
      if (!this.$refs.aisInstantSearch) return

      setTimeout(() => {
        const widgetState = this.$refs.aisInstantSearch.instantSearchInstance.mainIndex.getWidgetState({})

        if (!isEqual(this.uiData.appliedUiState, widgetState)) {
          this.uiData.appliedUiState = widgetState
          ++this.instantSearchRenderKey
        }
      }, 500)
    },
    onStateChange ({ uiState, setUiState }) {
      if (!this.searchOnConfirmation) {
        this.uiData.uiState = null
        this.uiData.appliedUiState = uiState
        setUiState(uiState)

        return
      }

      const page = this.getPageFromUiState(uiState)
      if (!!page) {
        let uiStateToApply = uiState

        if (!!this.uiData.appliedUiState) {
          uiStateToApply = merge(this.uiData.appliedUiState, { [this.indexName]: { page } })
        }

        this.uiData.uiState = null
        this.uiData.appliedUiState = uiStateToApply
        setUiState(uiStateToApply)

        return
      }

      this.uiData.uiState = uiState
      this.uiData.setUiState = setUiState
    },
    applyFilters () {
      if (!this.uiData.setUiState) return
      if (!this.uiData.uiState) return

      this.uiData.setUiState(this.uiData.uiState)
      this.uiData.appliedUiState = this.uiData.uiState
      this.uiData.uiState = null
    },
    getPageFromUiState (uiState) {
      return uiState?.[this.indexName]?.page
    }
  }
}